/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type PauseTriggerInstanceSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type PauseTriggerInstanceRequest = {
  /**
   * The trigger instance ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type PauseTriggerInstanceSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const PauseTriggerInstanceSecurity$outboundSchema: z.ZodMiniType<
  PauseTriggerInstanceSecurity$Outbound,
  PauseTriggerInstanceSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function pauseTriggerInstanceSecurityToJSON(
  pauseTriggerInstanceSecurity: PauseTriggerInstanceSecurity,
): string {
  return JSON.stringify(
    PauseTriggerInstanceSecurity$outboundSchema.parse(
      pauseTriggerInstanceSecurity,
    ),
  );
}

/** @internal */
export type PauseTriggerInstanceRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const PauseTriggerInstanceRequest$outboundSchema: z.ZodMiniType<
  PauseTriggerInstanceRequest$Outbound,
  PauseTriggerInstanceRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function pauseTriggerInstanceRequestToJSON(
  pauseTriggerInstanceRequest: PauseTriggerInstanceRequest,
): string {
  return JSON.stringify(
    PauseTriggerInstanceRequest$outboundSchema.parse(
      pauseTriggerInstanceRequest,
    ),
  );
}
